import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgCalendarIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="calendar_svg__nc-icon-wrapper">
      <path d="M32 12a1 1 0 0 1-1-1V2a1 1 0 0 1 2 0v9a1 1 0 0 1-1 1ZM15 12a1 1 0 0 1-1-1V2a1 1 0 0 1 2 0v9a1 1 0 0 1-1 1ZM49 12a1 1 0 0 1-1-1V2a1 1 0 0 1 2 0v9a1 1 0 0 1-1 1Z" />
      <path d="M35.587 55H6a1 1 0 0 1-1-1V21a1 1 0 0 1 1-1h52a1 1 0 0 1 1 1v20.211a14.065 14.065 0 0 1 2 2.605V9a2 2 0 0 0-2-2h-7v4a3 3 0 0 1-6 0V7H35v4a3 3 0 0 1-6 0V7H18v4a3 3 0 0 1-6 0V7H5a2 2 0 0 0-2 2v46a2 2 0 0 0 2 2h31.365a13.972 13.972 0 0 1-.778-2Z" />
      <path
        d="M49 39a12 12 0 1 0 12 12 12 12 0 0 0-12-12Zm5 13h-4v4a1 1 0 0 1-2 0v-4h-4a1 1 0 0 1 0-2h4v-4a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2Z"
        data-color="color-2"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgCalendarStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgCalendarIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const CalendarIcon: any = SvgCalendarStyle;
export default CalendarIcon;
